import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gateway',
  templateUrl: './gateway.component.html',
  styleUrls: ['./gateway.component.css']
})
export class GatewayComponent implements OnInit {

  basicPermission = true;
  authentication = false;
  initialWindow = true;
  security = false;
  trafficControl = false;
  serverless = false;
  analytics = false;
  basicAuth = false;
  keyAuth = false;
  oAuth2 = false;
  hmacAuth = false;
  jwtAuth = false;
  ldapAuth = false;
  acl = false;
  cors = false;
  ipRestriction = false;
  botDetection = false;
  rateLimiting = false;
  responseRateLimiting = false;
  requestSizeLimiting = false;
  requestTermination = false;
  awsLambda = false;
  preFunction = false;
  postFunction = false;
  azureFunctions = false;
  dataDog = false;
  prometheus = false;
  zipkin = false;
  categories = [
    {
      'parent' : 'Authentication',
      'displayName' : 'Authentication',
      'function' : 'showAuth()',
      'children' : [
        {
          'key': 'BasicAuth',
          'value': 'Basic authentication',
          'function': 'showBasicAuth()'
        },
        {
          'key': 'KeyAuth',
          'value': 'Key authentication',
          'function': 'showKeyAuth()'
        },
        {
          'key': 'OAuth2',
          'value': 'OAUTH2',
          'function' : 'showOAuth2()'
        },
        {
          'key': 'Hmac Auth',
          'value': 'HMAC authentication',
          'function' : 'showHmacAuth()'
        },
        {
          'key': 'Jwt',
          'value': 'JWT',
          'function' : 'showJwtAuth()'
        },
        {
          'key': 'Ldap Auth',
          'value': 'LDAP authentication',
          'function' : 'showLdapAuth()'
        }
      ]
    },
    {
      'parent' : 'Security',
      'displayName' : 'Security',
      'function' : 'showSecurity()',
      'children' : [
        {
          'key': 'Acl',
          'value': 'ACL',
          'function': 'showAcl()'
        },
        {
          'key': 'Cors',
          'value': 'CORS',
          'function': 'showCors()'
        },
        {
          'key': 'Ip Restriction',
          'value': 'IP Restriction',
          'function': 'showIPRestriction()'
        },
        {
          'key': 'Bot Detection',
          'value': 'BOT Detection',
          'function': 'showBotDetection()'
        }
      ]
    },
    {
      'parent' : 'TrafficControl',
      'displayName' : 'Traffic Control',
      'function' : 'showTrafficControl()',
      'children' : [
        {
          'key': 'Rate Limiting',
          'value': 'Rate Limiting',
          'function': 'showRateLimiting()'
        },
        {
          'key': 'Response RateLimiting',
          'value': 'Response Rate Limiting',
          'function' : 'showResponseRateLimiting()'
        },
        {
          'key': 'Request SizeLimiting',
          'value': 'Request Size Limiting',
          'function' : 'showRequestSizeLimiting()'
        },
        {
          'key': 'Request Termination',
          'value': 'Request Termination',
          'function' : 'showRequestTermination()'
        }
      ]
    },
    {
      'parent' : 'Serverless',
      'displayName' : 'Serverless',
      'function' : 'showServerless()',
      'children' : [
        {
          'key': 'AwsLambda',
          'value': 'AWS Lambda',
          'function' : 'showAwsLambda()'
        },
        {
          'key': 'PreFunction',
          'value': 'Pre-Function',
          'function' : 'showPreFunction()'
        },
        {
          'key': 'PostFunction',
          'value': 'Post Function',
          'function' : 'showPostFunction()'
        },
        {
          'key': 'AzureFunctions',
          'value': 'Azure Functions',
          'function' : 'showAzureFunctions()'
        }
      ]
    },
    {
      'parent' : 'Analytics-monitoring',
      'displayName' : 'Analytics & Monitoring',
      'function' : 'showAnalytics()',
      'children' : [
        {
          'key': 'DataDog',
          'value': 'Data Dog',
          'function' : 'showDataDog()'
        },
        {
          'key': 'Prometheus',
          'value': 'Prometheus',
          'function' : 'showPrometheus()'
        },
        {
          'key': 'Zipkin',
          'value': 'Zipkin',
          'function' : 'showZipkin()'
        }
      ]
    },
  ];


  showAuth() {
    this.authentication = true;
    this.initialWindow = false;
    this.security = false;
    this.trafficControl = false;
    this.serverless = false;
    this.analytics = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.oAuth2 = false;
    this.hmacAuth = false;
    this.jwtAuth = false;
    this.ldapAuth = false;
    this.acl = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;

  }
  showSecurity() {
    this.authentication = false;
    this.initialWindow = false;
    this.security = true;
    this.trafficControl = false;
    this.serverless = false;
    this.analytics = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.oAuth2 = false;
    this.hmacAuth = false;
    this.jwtAuth = false;
    this.ldapAuth = false;
    this.acl = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;

  }
  showTrafficControl() {
    this.authentication = false;
    this.initialWindow = false;
    this.security = false;
    this.trafficControl = true;
    this.serverless = false;
    this.analytics = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.oAuth2 = false;
    this.hmacAuth = false;
    this.jwtAuth = false;
    this.ldapAuth = false;
    this.acl = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;

  }
  showServerless() {
    this.authentication = false;
    this.initialWindow = false;
    this.security = false;
    this.trafficControl = false;
    this.serverless = true;
    this.analytics = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.oAuth2 = false;
    this.hmacAuth = false;
    this.jwtAuth = false;
    this.ldapAuth = false;
    this.acl = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;

  }
  showAnalytics() {
    this.authentication = false;
    this.initialWindow = false;
    this.security = false;
    this.trafficControl = false;
    this.analytics = true;
    this.serverless = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.oAuth2 = false;
    this.hmacAuth = false;
    this.jwtAuth = false;
    this.ldapAuth = false;
    this.acl = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;

  }

  showBasicAuth() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.basicAuth = true;
    this.keyAuth = false;
    this.oAuth2 = false;
    this.hmacAuth = false;
    this.jwtAuth = false;
    this.ldapAuth = false;
    this.acl = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }

  showKeyAuth() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.keyAuth = true;
    this.basicAuth = false;
    this.oAuth2 = false;
    this.hmacAuth = false;
    this.jwtAuth = false;
    this.ldapAuth = false;
    this.acl = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showOAuth2() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.oAuth2 = true;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.jwtAuth = false;
    this.ldapAuth = false;
    this.acl = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showHmacAuth() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = true;
    this.jwtAuth = false;
    this.ldapAuth = false;
    this.acl = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showJwtAuth() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.jwtAuth = true;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.acl = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;

  }
  showLdapAuth() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = true;
    this.acl = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showAcl() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = true;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }

  showCors() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = true;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showIPRestriction() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = true;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showBotDetection() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = true;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showRateLimiting() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = true;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showResponseRateLimiting() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.acl = false;
    this.authentication = false;
    this.initialWindow = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = true;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showRequestSizeLimiting() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = true;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showRequestTermination() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = true;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showAwsLambda() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = true;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showPreFunction() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = true;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showPostFunction() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = true;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showAzureFunctions() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = true;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = false;
  }
  showDataDog() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = true;
    this.prometheus = false;
    this.zipkin = false;
  }
  showPrometheus() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = true;
    this.zipkin = false;
  }
  showZipkin() {
    this.serverless = false;
    this.analytics = false;
    this.trafficControl = false;
    this.security = false;
    this.authentication = false;
    this.initialWindow = false;
    this.acl = false;
    this.jwtAuth = false;
    this.oAuth2 = false;
    this.basicAuth = false;
    this.keyAuth = false;
    this.hmacAuth = false;
    this.ldapAuth = false;
    this.cors = false;
    this.ipRestriction = false;
    this.botDetection = false;
    this.rateLimiting = false;
    this.responseRateLimiting = false;
    this.requestSizeLimiting = false;
    this.requestTermination = false;
    this.awsLambda = false;
    this.preFunction = false;
    this.postFunction = false;
    this.azureFunctions = false;
    this.dataDog = false;
    this.prometheus = false;
    this.zipkin = true;
  }

  whatever () {}

  categoryClick(item) {
    switch (item.function) {
      case 'showAuth()' :
        this.showAuth();
        break;
      case 'showSecurity()' :
        this.showSecurity();
        break;
      case 'showTrafficControl()' :
        this.showTrafficControl();
        break;
      case 'showServerless()' :
        this.showServerless();
        break;
      case 'showAnalytics()' :
        this.showAnalytics();
        break;
      default: this.whatever();
    }
  }


  onClick(item) {
    switch (item.function) {
      case 'showBasicAuth()' :
        this.showBasicAuth();
        break;
      case 'showKeyAuth()' :
        this.showKeyAuth();
        break;
      case 'showOAuth2()' :
        this.showOAuth2();
        break;
      case 'showHmacAuth()' :
        this.showHmacAuth();
        break;
      case 'showJwtAuth()' :
        this.showJwtAuth();
        break;
      case 'showLdapAuth()' :
        this.showLdapAuth();
        break;
      case 'showAcl()' :
        this.showAcl();
        break;
      case 'showCors()' :
        this.showCors();
        break;
      case 'showIPRestriction()' :
        this.showIPRestriction();
        break;
      case 'showBotDetection()' :
        this.showBotDetection();
        break;
      case 'showRateLimiting()' :
        this.showRateLimiting();
        break;
      case 'showResponseRateLimiting()' :
        this.showResponseRateLimiting();
        break;
      case 'showRequestSizeLimiting()' :
        this.showRequestSizeLimiting();
        break;
      case 'showRequestTermination()' :
        this.showRequestTermination();
        break;
      case 'showAwsLambda()' :
        this.showAwsLambda();
        break;
      case 'showPreFunction()' :
        this.showPreFunction();
        break;
      case 'showPostFunction()' :
        this.showPostFunction();
        break;
      case 'showAzureFunctions()' :
        this.showAzureFunctions();
        break;
      case 'showDataDog()' :
        this.showDataDog();
        break;
      case 'showPrometheus()' :
        this.showPrometheus();
        break;
      case 'showZipkin()' :
        this.showZipkin();
        break;
      default: this.whatever();
    }
  }

  constructor() { }


  ngOnInit() {
  }
}
